import { API_BASE_PATH } from '../../../Shared/constants';

export const GET_TIME_PERIODS_URL = `${API_BASE_PATH}/SendOptimizer/time-periods`;
export const GET_CHANNELS_URL = `${API_BASE_PATH}/SendOptimizer/channels/{buId}`;
export const GET_USER_DATA_URL = `${API_BASE_PATH}/UserData/token/{rootMID}/{token}`;
export const GET_LIMITS_URL = `${API_BASE_PATH}/SendOptimizer/limits/{buId}`;
export const GET_ACTIVITY_TYPES_URL = `${API_BASE_PATH}/SendOptimizer/activityTypes`;
export const GET_METRICS_URL = `${API_BASE_PATH}/SendOptimizer/metrics`;
export const GET_ISHCOENABLED_URL = `${API_BASE_PATH}/SendOptimizer/isHCOFeatureEnabled/{buId}`;

export const ConfigurationPageForm = 'ConfigurationPageForm';
export const AvailableFeaturesForm = 'AvailableFeaturesForm';
export const BestDayTimePageForm = 'BestDayTimePageForm';

export const MessageFrequencyCapping = 'activityTypes_MessageCapping';
export const BestDayTime = 'BestDayTime';



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/constants/index.js